import styled from 'styled-components';
import { blockquoteCSS, getOrderedListCSS, getTextSizeCSS, tableCSS } from '../../styles';
export const StyledMarkdown = styled.div `
  ${({ orderedListAppearance }) => getOrderedListCSS(orderedListAppearance)}
  ${({ textSize }) => getTextSizeCSS(textSize)}
  ${blockquoteCSS}
  ${tableCSS}
`;
//# sourceMappingURL=UiMarkdown.styled.js.map